import { ReactNode, useState } from 'react'
import { MarkerF, OverlayViewF, OverlayView } from '@react-google-maps/api'
import { Paper } from '@mui/material'

interface IProps {
  marker: {
    lat: number
    lng: number
  }
  icon: string
  info: ReactNode
  zIndex?: number
}

export const CustomMarker = ({ marker, icon, info, zIndex = 1 }: IProps) => {
  const [markOpened, setMarkOpened] = useState<boolean>(false)
  const [overlayzIndex, setOverlayZIndex] = useState<number>(1)

  const handleMouseEnterMarker = () => {
    setMarkOpened(true)
    setOverlayZIndex(1000)
  }

  const handleMouseLeaveMarker = () => {
    setMarkOpened(false)
    setOverlayZIndex(1)
  }

  const handleMouseEnterPopup = () => {
    setMarkOpened(true)
    setOverlayZIndex(1000)
  }

  const handleMouseLeavePopup = () => {
    setMarkOpened(false)
    setOverlayZIndex(1)
  }

  return (
    <>
      <MarkerF
        icon={icon}
        key={marker.lat + marker.lng}
        position={{
          lat: marker.lat,
          lng: marker.lng,
        }}
        onMouseOver={handleMouseEnterMarker}
        onMouseOut={handleMouseLeaveMarker}
        onMouseDown={() => {
          setMarkOpened(true)
          setOverlayZIndex(1000)
        }}
        zIndex={zIndex}
      />

      <OverlayViewF
        position={{ lat: marker.lat, lng: marker.lng }}
        mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
        getPixelPositionOffset={(width, height) => ({ x: -width / 2, y: -height / 1.2 })}
        zIndex={overlayzIndex}
      >
        {markOpened && (
          <Paper
            sx={{
              display: 'flex',
              flexDirection: 'column',
              borderRadius: '3px',
              borderBlockColor: '#000',
              padding: '5px',
              backgroundColor: '#fff',
              cursor: 'pointer',
            }}
            onMouseEnter={handleMouseEnterPopup}
            onMouseLeave={handleMouseLeavePopup}
          >
            {info}
          </Paper>
        )}
      </OverlayViewF>
    </>
  )
}
